import {DEFAULT_CURRENCY_CODE, Injector, NgModule} from '@angular/core'
import {BrowserModule} from '@angular/platform-browser'
import {AppRoutingModule} from './modules/app-routing.module'
import {AppComponent} from './app.component'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import { HTTP_INTERCEPTORS, HttpBackend, provideHttpClient, withInterceptorsFromDi, withXsrfConfiguration } from '@angular/common/http'
import {MissingTranslationHandler, TranslateLoader, TranslateModule} from '@ngx-translate/core'
import {createTranslateLoader, SharedModule} from './modules/shared/shared.module'
import {ApiInterceptor} from './services/api/api.interceptor'
import {LoggerModule, NgxLoggerLevel} from 'ngx-logger'
import {defineLocale, deLocale, enGbLocale} from 'ngx-bootstrap/chronos'
import {registerLocaleData} from '@angular/common'
import localeEn from '@angular/common/locales/en'
import localeDe from '@angular/common/locales/de'
import {CanActivateGuard} from './guard/can-activate-guard.service'
import {ServicesModule} from './services/services.module'
import {LocaleProvider} from "./services/locale.provider";
import {BugsnagMissingTranslationHandlerService} from "./services/bugsnag-missing-translation-handler.service";
import {CloudflareInterceptor} from "./services/api/cloudflare.interceptor";
import {CloudflareTurnstileModalComponent} from "./services/cloudflare/cloudflare-turnstile-modal.component";
import {provideScrollbarOptions} from "ngx-scrollbar";
import {IdempotencyInterceptor} from "./services/api/idempotency.interceptor";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
declare const BUGSNAG_API_KEY: string;

// ngx-bootstrap locale
defineLocale('de', deLocale)
defineLocale('en', enGbLocale)

// angular locale
registerLocaleData(localeEn, 'en')
registerLocaleData(localeDe, 'de')

// if(environment.env_name === 'production' || environment.env_name === 'stage') Bugsnag.start({
//   apiKey: BUGSNAG_API_KEY || 'unknown',
//   releaseStage: environment.env_name,
//   autoTrackSessions: false,
//   autoDetectErrors: false,
// })

@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent
  ],
  imports: [BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: BugsnagMissingTranslationHandlerService
      },
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpBackend]
      }
    }),
    LoggerModule.forRoot({
      level: NgxLoggerLevel.DEBUG,
      serverLogLevel: undefined,
      serverLoggingUrl: undefined
    }),
    SharedModule,
    ServicesModule, CloudflareTurnstileModalComponent],
  providers: [
    CanActivateGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      deps: [Injector],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: IdempotencyInterceptor,
      deps: [Injector],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CloudflareInterceptor,
      deps: [Injector],
      multi: true
    },
    {provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR'},
    LocaleProvider,
    provideHttpClient(withInterceptorsFromDi(), withXsrfConfiguration({
      cookieName: 'XSRF-TOKEN',
      headerName: 'X-XSRF-TOKEN',
    })),
    provideScrollbarOptions({
      visibility: 'hover',
    }),
  ]
})
export class AppModule {
}
